module.exports = "/images/role-marketer-icon.svg?34f0e4dc9bd5b0deca89742e8c2d1fb4";